import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const problems = ['Każdy nowy dział oznacza kolejne notatki, ćwiczenia i sprawdzian.', 'Materiały są rozproszone po folderach i stronach internetowych.', 'Trudne pojęcia wymagają długich wyjaśnień.', 'Planowanie zaczyna się od nowa co tydzień.'];
const solutions = ['Prowadzisz uczniów przez spójną kolejność tematów.', 'Masz wizualne strony teorii oraz gotowe zadania do wydruku.', 'Korzystasz ze sprawdzianów, kluczy i planów zamiast tworzyć je od zera.', 'Dopasowujesz materiały do pracy indywidualnej, grupowej, powtórki lub oceny.'];
export function ProblemSolution() {
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-197" data-mp="4lge9xomfog4">
      <div className="mx-auto max-w-5xl" data-id="element-198" data-mp="4ikfk74y8vqm">
        <h2 className="mx-auto max-w-2xl text-center font-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-199" data-mp="120aqw0v9ocfm">
          Nie musisz już spędzać wieczorów na składaniu lekcji chemii z przypadkowych plików.
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-200" data-mp="6t2dxb4k34yv">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-rose-100 border-l-4 border-l-rose-300 bg-rose-soft p-6 sm:p-8" data-id="element-201" data-mp="brvg47ee79jq">
            <h3 className="mb-5 text-lg font-bold text-ink sm:text-xl" data-id="element-202" data-mp="3k9i2w0ffd389">
              Gdy wszystko tworzysz samodzielnie
            </h3>
            <ul className="space-y-3" data-id="element-203" data-mp="3b78yztenw83u">
              {problems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-204" data-mp="3f82k6f0pz8t1">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose-100 text-rose-600" data-id="element-205" data-mp="3faez0jb6l31v">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-206" data-mp="1dgpf9pyr50wz" />
                  </span>
                  <span className="text-sm leading-relaxed text-ink/80" data-id="element-207" data-mp="2mdnyzdatucpa">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-chem/20 border-l-4 border-l-chem bg-chem-soft p-6 sm:p-8" data-id="element-208" data-mp="2hdi0pea1xry8">
            <h3 className="mb-5 text-lg font-bold text-chem-deep sm:text-xl" data-id="element-209" data-mp="313v6wz37kdbq">
              Z Wizualną Chemią™
            </h3>
            <ul className="space-y-3" data-id="element-210" data-mp="2wais1gobzkw6">
              {solutions.map(item => <li key={item} className="flex items-start gap-3" data-id="element-211" data-mp="2rc7kjclidmh4">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-chem/15 text-chem-deep" data-id="element-212" data-mp="3oswl72yq2iox">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-213" data-mp="3k0wfsuzvuxky" />
                  </span>
                  <span className="text-sm leading-relaxed text-ink/80" data-id="element-214" data-mp="3re48s3if43yt">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}